import {OpenImprintCommandHandler} from './open-imprint.command-handler';
import {DomainCommand} from '../../modules/command-bus/command';

export class OpenImprintCommand extends DomainCommand {
  constructor() {
    super(OpenImprintCommandHandler);
  }
}
